import { notificationSettings } from "@/api";


function supportsBrowserPush() {
  return (
    typeof window !== "undefined" &&
    typeof navigator !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}


export async function getExistingPushSubscription() {
  if (!supportsBrowserPush()) {
    return null;
  }

  const registration =
    await navigator.serviceWorker
      .getRegistration("/");

  if (!registration) {
    return null;
  }

  return registration.pushManager
    .getSubscription();
}


export async function syncExistingPushSubscription() {
  const subscription =
    await getExistingPushSubscription();

  if (
    !subscription ||
    Notification.permission !== "granted"
  ) {
    return {
      synced: false,
      subscription: null,
    };
  }

  await notificationSettings.subscribePush(
    subscription.toJSON()
  );

  return {
    synced: true,
    subscription,
  };
}


export async function deactivateExistingPushSubscription() {
  const subscription =
    await getExistingPushSubscription();

  if (!subscription) {
    return {
      deactivated: false,
    };
  }

  await notificationSettings.unsubscribePush(
    subscription.toJSON()
  );

  return {
    deactivated: true,
  };
}
